/**
 * Rollup Fee Service
 * Helper functions to get rollup fee names by ID
 */

/**
 * Get rollup fee name by ID
 * @param {Number|String} feeId - Rollup fee ID
 * @param {Object} store - Vuex store instance
 * @returns {String|null} - Fee name or null if not found
 */
export function getRollupFeeName(feeId, store) {
    if (!feeId || !store) return null;
    return store.getters['rollupFees/getRollupFeeName'](feeId);
}

/**
 * Get rollup fee display name by ID (uses display_name field)
 * @param {Number|String} feeId - Rollup fee ID
 * @param {Object} store - Vuex store instance
 * @returns {String|null} - Fee display name or null if not found
 */
export function getRollupFeeDisplayName(feeId, store) {
    if (!feeId || !store) return null;
    return store.getters['rollupFees/getRollupFeeDisplayName'](feeId);
}

/**
 * Get full rollup fee object by ID
 * @param {Number|String} feeId - Rollup fee ID
 * @param {Object} store - Vuex store instance
 * @returns {Object|null} - Fee object or null if not found
 */
export function getRollupFeeById(feeId, store) {
    if (!feeId || !store) return null;
    return store.getters['rollupFees/getRollupFeeById'](feeId);
}

/**
 * Vue Mixin for rollup fees
 * Use this in components to access rollup fee helpers
 */
export const rollupFeeMixin = {
    methods: {
        /**
         * Get rollup fee name by ID
         * @param {Number|String} feeId - Rollup fee ID
         * @returns {String|null} - Fee name or null if not found
         */
        getRollupFeeName(feeId) {
            if (!feeId || !this.$store) return null;
            const getter = this.$store.getters['rollupFees/getRollupFeeName'];
            return getter ? getter(feeId) : null;
        },
        /**
         * Get rollup fee display name by ID
         * @param {Number|String} feeId - Rollup fee ID
         * @returns {String|null} - Fee display name or null if not found
         */
        getRollupFeeDisplayName(feeId) {
            if (!feeId || !this.$store) return null;
            const getter = this.$store.getters['rollupFees/getRollupFeeDisplayName'];
            return getter ? getter(feeId) : null;
        },
        /**
         * Get rollup fee object by ID
         * @param {Number|String} feeId - Rollup fee ID
         * @returns {Object|null} - Fee object or null if not found
         */
        getRollupFeeById(feeId) {
            if (!feeId || !this.$store) return null;
            const getter = this.$store.getters['rollupFees/getRollupFeeById'];
            return getter ? getter(feeId) : null;
        }
    }
};

